export const headerTypeData = {
    umu: 1,
    use: 2,
};
